import {axiosPostAuthorize} from '../AxiosRequests';
import {AddVendorPreferences,GetUnAssignVendorsPreference,GetAllAssignVendorsForMandate,GetAllAssignVendorsForBlock,GetAllMandateVendorsEmailAddress} from '../ApiEndPoints';

export default class VendorPreferenceServices {

        //** Call API : */
        async getUnAssignVendorsPreference(request) {
            return axiosPostAuthorize(GetUnAssignVendorsPreference, request);
        }

        async getAllAssignVendorsForMandate(request) {
            return axiosPostAuthorize(GetAllAssignVendorsForMandate, request);
        }
        
        async getAllAssignVendorsForBlock(request) {
            return axiosPostAuthorize(GetAllAssignVendorsForBlock, request);
        }
        async addVendorPreferences(request) {
            return axiosPostAuthorize(AddVendorPreferences, request);
        }
        async getAllMandateVendorsEmailAddress(request) {
            return axiosPostAuthorize(GetAllMandateVendorsEmailAddress, request);
        }   
   
}